"use client";
import { useState, useEffect, useCallback } from "react";

export function useStore<T>(listFn: () => Promise<T[]>): T[] {
  const [data, setData] = useState<T[]>([]);

  const refresh = useCallback(() => {
    listFn().then(setData).catch(() => {});
  }, [listFn]);

  useEffect(() => {
    refresh();
    const handler = () => refresh();
    window.addEventListener("store-update", handler);
    return () => window.removeEventListener("store-update", handler);
  }, [refresh]);

  return data;
}
